module.exports = __webpack_public_path__ + "static/img/icon_fullscreen.34d07456.svg";